// Старые WebView (Android 11 = Chrome 90): Object.hasOwn и др. — ДО React и всего кода
import './polyfills'
import './index.css'
import { initI18n } from './i18n/runtime'

// Язык интерфейса и его каталоги — до кода приложения: тексты модулей вычисляются уже на
// нужном языке (t() можно и в константах), смена языка = перезагрузка. Код — в boot.tsx.
initI18n()
  .catch((e) => console.error('[i18n]', e))
  .then(() => import('./boot'))
